import React, { Component } from 'react';
import '../css/Manuales.css';
import iconalmacen from '../img/iconalmacen.png';
import iconlogistica from '../img/iconlogistica.png';
import iconventas from '../img/iconventas.png';
import cajas from '../img/cajas.png';
import Almacem from '../archivos/MANEJO_ALMACEN.pdf';
import ManejoCaja from '../archivos/MANEJO_CAJA.pdf';
import Ventas from '../archivos/MANEJO_VENTAS.pdf';
import logistica from '../archivos/LOGISTICA.pdf';

class Manuales extends Component {
  render() {
    return (
      <div id="id-manuales" className="panelManuales">
        <div id="manuales" className='fondo-manuales'>
          <div className="cuadroprimario">
            <h1 className="tituloprimario">Manuales</h1>
            <p className="parrafoprimario">Acceso al Soporte del Sistema</p>
          </div>
          <div className="pasoprincipal">
            <div class="panel panel-primary" id="finalcuadro">
              <div class="panel-heading" id="heading1">
                <h3 class="panel-title" id="title1">Manual de Almacenes </h3>
              </div>
              <div class="panel-body" id="manual-almacen">
                <h4 className="contenido-class">Contenido</h4>
                <div className="dessarolloManuales">
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon1"></i>
                    <p className="parrafoManuales">¿Como Ingresar los datos de un articulo?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon2"></i>
                    <p className="parrafoManuales">¿Como valorizar cada articulo del almacen?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon3"></i>
                    <p className="parrafoManuales">¿Como visualizar el stock de articulos en el almacen?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon4"></i>
                    <p className="parrafoManuales">¿Como visualizar el kardex por articulo del almacen?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon5"></i>
                    <p className="parrafoManuales">¿Como visualizar el stock valorizado del almacen?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-fast-forward" id="glyphicon6"></i>
                    <p className="parrafoManuales">Soluciones en Sistemas Informáticos</p>
                  </div>
                </div>
              </div>
            </div>
            <div id="primativacampus" class="panel panel-primary">
              <div class="panel-heading" id="heading2">
                <h3 class="panel-title" id="title2">Manual de Logistica</h3>
              </div>
              <div class="panel-body" id="manual-logistica">
                <h4 className="logisticatexto">Contenido</h4>
                <div className="dessarolloManuales">
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon7" ></i>
                    <p className="parrafoManuales">¿Como Realizar una Emision de documentos?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon8" ></i>
                    <p className="parrafoManuales">¿Como Ingresar al modulo de logistica?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon9"></i>
                    <p className="parrafoManuales">¿Como Realizar un registro de ENV. de documentos aprobados?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon10" ></i>
                    <p className="parrafoManuales">¿Como Realizar una orden de requerimiento y aprobarla?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon11" ></i>
                    <p className="parrafoManuales">¿Como Realizar un registro de solicitud de cotizaciones?</p>
                  </div>
                  <div className="inflaFlex2">
                    <i class="glyphicon glyphicon-fast-forward" id="glyphicon12" ></i>
                    <p className="parrafoManuales2">Soluciones en Sistemas Informáticos</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-primary" id="modulo-ventas">
              <div class="panel-heading" id="heading3">
                <h3 class="panel-title" id="title3">Manual de Ventas</h3>
              </div>
              <div class="panel-body" id="manual-contabilidad">
                <h4 className="contenidoContabilidad">Contenido</h4>
                <div className="dessarolloManuales">
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon13"></i>
                    <p className="parrafoManuales">¿Como Ingresar los condiciones de pago?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon14"></i>
                    <p className="parrafoManuales">¿Como Ingresar al modulo de ventas?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon15"></i>
                    <p className="parrafoManuales">¿Como Realizar una nota de pedido y aprobarla?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon16"></i>
                    <p className="parrafoManuales">¿Como visualizar el reporte de ventas valorizado?</p>
                  </div>
                  <div className="inflar-flex">
                    <i class="glyphicon glyphicon-ok" id="glyphicon17"></i>
                    <p className="parrafoManuales">¿Como visualizar el kardex por articulo ?</p>
                  </div>
                  <div className="inflaFlex2">
                    <i class="glyphicon glyphicon-fast-forward" id="glyphicon18"></i>
                    <p className="parrafoManuales2">Soluciones en Sistemas Informáticos</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="campoManules">
            <div className="barraManuales">
              <div className="contenidoTitulos">
                <h5 className="tituloBarra">Para iniciar sesión, contactese con su proveedor de sistemas para que le brinde su usuario y password.</h5>
                <h5 className="tituloBarra2">dandole click en contacto.</h5>
              </div>
              <a id='btn-contac' className="btn btn-primary" href="#contactos-final">
                <p className="parrafoContact">Contacto</p></a>
            </div>
            <div className="divisionManuales1">
              <div className="divisioncampo1">
                <h2 className="titulodivision">Iniciar Sesion</h2>
              </div>
              <div class="input-group">
                <span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span>
                <input id="usuario" type="text" class="form-control" name="usua" placeholder="Usuario" />
              </div>
              <div class="input-group">
                <span class="input-group-addon"><i class="glyphicon glyphicon-lock"></i></span>
                <input id="password" type="password" class="form-control" name="password" placeholder="Password" />
              </div>
              <a id="btn-primary-cuadro" className="btn btn-primary" href="#cuadro">
                <p className="texto-primary">Ingresar</p></a>
            </div>
          </div>
        </div>
        <div class="modal-wrapper" id="cuadro">
          <div class="cuadro-contenedor">
            <h2 className="cambioh2"> Manuales</h2>
            <div className="inflar-flex">
              <div>
                <h4>Almacenes</h4>
                <img className="imagenManuales" src={iconalmacen}></img>
                <a href={Almacem} download="Manual_Almacen.pdf" id="convertireEnlaces1" class="btn btn-primary" target="_blank">Descargar</a>
              </div>
              <div className="almacenes1">
                <h4>Logistica</h4>
                <img className="imagenManuales" src={iconlogistica}></img>
                <a href={logistica} download="Manual_Logistica.pdf" id="convertireEnlaces2" class="btn btn-primary" target="_blank">Descargar</a>
              </div>
              <div className="ventas1">
                <h4>Ventas</h4>
                <img className="imagenManuales" src={iconventas}></img>
                <a href={Ventas} download="Manual_Ventas.pdf" id="convertireEnlaces3" class="btn btn-primary" target="_blank">Descargar</a>
              </div>
              <div className="cajas1">
                <h4>Cajas</h4>
                <img className="imagenManuales" src={cajas}></img>
                <a href={ManejoCaja} download="Manual_Caja.pdf" id="convertireEnlaces4" class="btn btn-primary" target="_blank">Descargar</a>
              </div>
            </div>
            <a class="cuadro-cerrar" href="#manuales">X</a>
          </div>
        </div>
      </div>
    )
  }
}

export default Manuales;


// WEBPACK FOOTER //
// ./src/components/Manuales.jsx